export default {
    data: () => ({
        otherEvents: [],
        wrapupEvents: [],
        completedEvents: [],
        cancelledEvents: [],
        sortedEvents: []
    }),
    methods: {
        filterEvents(events) {
            this.otherEvents = events
                .filter((event) => event.status <= 2)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            this.wrapupEvents = events
                .filter((event) => event.status === 3)
                .sort((a, b) => new Date(b.end_date) - new Date(a.end_date))
            this.completedEvents = events
                .filter((event) => event.status === 4)
                .sort((a, b) => new Date(b.end_date) - new Date(a.end_date))
            this.cancelledEvents = events
                .filter((event) => event.status >= 5)
                .sort((a, b) => new Date(b.end_date) - new Date(a.end_date))
            this.sortedEvents = [
                ...this.otherEvents,
                ...this.wrapupEvents,
                ...this.completedEvents,
                ...this.cancelledEvents
            ]
            return this.sortedEvents
        }
    }
}
